import { Button, Stack, Text, useViewport } from "@bookingcom/bui-react";
import React, { useEffect, useMemo } from "react";
import NotAvailableIllustration from "../../../assets/illustrations/not-available.svg";
import useUserAgent from "../../../hooks/useUserAgent.js";
import { actions as AriaLiveActions } from "../../../store/ariaLive/actions.js";
import { useActions } from "../../../store/index.js";
import { useSelector } from "react-redux";
import { getVisible } from "../../../store/loadingScreen/selectors.js";
import useModalDialog from "../../../hooks/useModalDialog.js";
import styles from "./ErrorAlert.module.css";
import useGlobalContext from "../../../hooks/useGlobalContext.js";
import useEventTracking from "../../../hooks/useEventTracking.js";
import { mcn } from "../../../utils/mergeClassnames.js";
export const ErrorAlertInner = ({ illustration, title, body, buttonLabel, loading = false, onClick, children, size = "large", variant = "neutral" }) => {
    const Modal = useModalDialog();
    const { isMobile } = useUserAgent();
    const { isSmall } = useViewport();
    return (React.createElement(Modal, { title: "", subtitle: "", closeAriaLabel: "Close bottom sheet", active: true, fill: true, size: size, position: isMobile ? "fullScreen" : "center", lockClose: true, lockCloseOnOutsideClick: false, hideClose: true, zIndex: 500, className: isSmall ? styles.modalSm : "" },
        React.createElement(Stack, { direction: "column", justifyContent: "center", alignItems: "center" },
            React.createElement(Stack.Item, { className: mcn(styles.illustrationContainer, variant === "white" && styles.illustrationContainer_white) }, illustration || React.createElement(NotAvailableIllustration, null)),
            React.createElement(Stack, { direction: "column", justifyContent: "center", alignItems: "center", mixin: { width: "100%", padding: 4 } },
                React.createElement(Stack.Item, null,
                    React.createElement(Text, { tagName: "h1", variant: "headline_2" }, title)),
                React.createElement(Stack.Item, null, body ? React.createElement(Text, { variant: "body_2" }, body) : children),
                React.createElement(Stack.Item, { className: isSmall ? styles.buttonContainerSm : "" },
                    React.createElement(Button, { className: mcn(styles.button, isSmall && styles.buttonSm), onClick: onClick, loading: loading, wide: true, loadingAriaLabel: "" }, buttonLabel))))));
};
const ErrorAlert = (props) => {
    const { title, onClick, ...rest } = props;
    const ariaLiveActions = useActions(AriaLiveActions);
    const visible = useSelector(getVisible);
    const { requestId } = useGlobalContext();
    const trackV2 = useEventTracking("page_load", requestId);
    useEffect(() => {
        trackV2("show_error_page");
    }, [trackV2]);
    useEffect(() => {
        if (visible && title) {
            ariaLiveActions.setMessage({
                message: title,
                type: "assertive"
            });
        }
        else {
            ariaLiveActions.reset();
        }
    }, [ariaLiveActions, visible, title]);
    const errorAlert = useMemo(() => React.createElement(ErrorAlertInner, { title: title, onClick: onClick, ...rest }), [rest, title, onClick]);
    return errorAlert;
};
export default ErrorAlert;
